import type { ParentComponent } from "solid-js";

const Layout: ParentComponent = (props) => (
  <main class="flex h-dvh grow flex-col justify-center-safe overflow-hidden bg-surface-default mobile:bg-surface-extra-subtle">
    <div class="flex w-full grow flex-col overflow-hidden">{props.children}</div>
  </main>
);

export default Layout;
